import { IConfig, UnleashClient } from "@unleash/proxy-client-vue"

import { config as appConfig } from "@/app.config"

const { VUE_APP_UNLEASH_FE_API_TOKEN, VUE_APP_FILES_LOCATION } = appConfig
const UNLEASH_APP_NAME = "fe-project-simple"
const UNLEASH_URL = `${VUE_APP_FILES_LOCATION}/unleash/api/frontend`
const UNLEASH_REFRESH_INTERVAL = 300

const config = {
  url: UNLEASH_URL,
  clientKey: VUE_APP_UNLEASH_FE_API_TOKEN,
  refreshInterval: UNLEASH_REFRESH_INTERVAL,
  appName: UNLEASH_APP_NAME
} as IConfig

export const unleashClient = new UnleashClient(config)
